module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"administration":"Administration","contact":"Kontakt per E-Mail","map":"Karte","menu":"Menü","partners":"Partner","spots":"Spots","trucks":"Trucks"},"en":{"administration":"Administration","contact":"Contact via email","map":"Map","menu":"Menu","partners":"Partners","spots":"Spots","trucks":"Trucks"}}')
  delete Component.options._Ctor
}
